<template>
  <b-modal
    id="accept-modal"
    ref="accept-modal"
    title="Xác nhận thông tin"
    size="xl"
    :hide-header-close="true"
    :no-close-on-backdrop="true"
  >
    <b-overlay>
      <h4 style="text-align: center">Thông tin khách hàng tham gia</h4>
      <template-table
        :column="infoTable"
        :data="data"
        :searchAction="false"
        :pagingAction="false"
        :selectAction="false"
        :tableAction="false"
        class="mt-3"
        bordered
      >
        <template v-slot:body="{ item }">
          <td>{{ item.name }}</td>
          <td>
            <span v-if="item.isZaloLinked === true" class="badge-login-type badge-zalo">Zalo</span>
            <span v-else-if="item.isZaloLinked === false" class="badge-login-type badge-google"><img src="/media/svg/logos/google-icon.svg" class="badge-google__icon" alt="" />Google</span>
            <span v-else>{{ item.phoneNumber }}</span>
          </td>
          <td>{{ item.packageName }}</td>
          <td>{{ item.packageCode }}</td>
          <!-- <td>{{ item.customerPartnerName }}</td> -->
          <td class="title-cell">
            <basic-select
              class="title-select"
              :class="{ 'is-invalid': submitted && !form.title }"
              placeholder="Chọn danh xưng"
              name="title"
              :options="titleOpts"
              :solid="false"
              :allowEmpty="false"
              :required="true"
              track-by="value"
              value-label="text"
              v-model="form.title"
              :value.sync="form.title"
              changeValueByObject
              data-vv-as="Danh xưng"
            />
            <span v-if="submitted && !form.title" class="text-danger small">Bắt buộc</span>
          </td>
          <td class="zalo-cell">
            <basic-select
              class="zalo-select"
              placeholder="Chọn"
              name="useZaloGroup"
              :options="useZaloGroupOpts"
              :solid="false"
              :allowEmpty="false"
              track-by="value"
              value-label="text"
              v-model="form.useZaloGroup"
              :value.sync="form.useZaloGroup"
              changeValueByObject
            />
          </td>
        </template>
      </template-table>

      <!-- Chọn nhóm cụ thể, chỉ hiện khi đã chọn "Nhóm chung" -->
      <div v-if="isSharedMode" class="shared-picker">
        <label class="m-0 mr-2">Chọn nhóm chung:</label>
        <select
          class="form-control form-control-sm bulk-select"
          v-model="sharedGroupId"
          :disabled="loadingGroups"
        >
          <option :value="null">--- Chọn nhóm ---</option>
          <option
            v-for="group in zaloGroups"
            :key="group.group_id"
            :value="group.group_id"
          >
            {{ group.name }} ({{ group.total_member }} TV)
          </option>
        </select>
        <span v-if="loadingGroups" class="ml-2 text-muted">
          Đang tải danh sách nhóm...
        </span>
        <span v-else-if="!zaloGroups.length" class="ml-2 text-danger">
          Không lấy được nhóm Zalo nào
        </span>
        <span v-else-if="!sharedGroupId" class="ml-2 text-danger">
          Chưa chọn nhóm
        </span>
      </div>

      <!-- Khách chưa có tài khoản thì luôn được gửi thông tin đăng nhập, không cần hỏi.
           Chỉ khách ĐÃ có tài khoản mới cần admin chủ động cấp lại mật khẩu nếu muốn báo.
           Khách chỉ dùng Zalo/Google không có SDT thật để nhận ZNS nên không hiện option này. -->
      <div
        v-if="targetItem && targetItem.hasAccount && targetItem.isZaloLinked == null"
        class="notify-existing mt-4"
      >
        <label class="checkbox-inline reset-password-check m-0">
          <input type="checkbox" v-model="form.resetPassword" />
          Đặt lại mật khẩu và gửi ZNS
        </label>
      </div>

      <!-- <b-container fluid class="p-0">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col>
              <basic-select :options="courses" name="course" label="Chọn nhóm tham gia có sẵn"
                :value="getNameOf('course', this.form.courseId)"
              
                placeholder="--- Chọn nhóm tham gia ---" track-by="value" value-label="text"
                :hideSelected="true" :clear="false" :solid="false" changeValueByObject 
                :disabled="true"/>
            </b-col>
          </b-row>
        </form>
      </b-container> -->
      <!-- <basic-select
        :options="courseId"
        track-by="id"
        value-label="text"
        :value.sync="courseId"
        v-model="courseId"
      /> -->    </b-overlay>
    <template #modal-footer>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button
          class="btn btn-plain ml-2"
          href="#"
          @click.stop="handleCancel"
          tabindex="0"
        >
          Thoát
        </b-button>
        <b-button
          class="btn btn-success ml-2"
          href="#"
          @click.stop="handleSubmit"
          tabindex="0"
          :disabled="loading"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Xác nhận
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { handleZaloOutOfMoney } from '@/core/utils/zaloOutOfMoney';
const { mapState } = createNamespacedHelpers('customerReceives');

const ZALO_GROUP_PAGE_SIZE = 50; // giới hạn của getgroupsofoa
const ZALO_GROUP_MAX_PAGE = 10;

export default {
  name: 'AcceptModal',
  props: {
    targetItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        id: null,
        packageName: null,
        phoneNumber: null,
        name: null,
        packageCode: null,
        courseId: null,
        packageId: null,
        coachId: null,
        customerPartnerName: null,
        gender: null,
        title: null,
        birthYear: null,
        yearOfIllness: null,
        purchaseDate: null,
        reasonout: null,
        diseaseType: null,
        contactSource: null,
        status: null,
        onboardGroup: null,
        useZaloGroup: { text: 'Không', value: 'none' },
        // Mặc định tắt: đây là thao tác gửi tin cho khách, admin phải chủ động bật
        resetPassword: false,
      },
      // courseId: [
      //   { id: '350a3050-c0f7-11ef-b57a-03ea338ae610', text: 'ONBOARDING' },
      // ],     
      loading: false,
      submitted: false,
      infoTable: [
        { label: 'Tên khách hàng', key: 'name' },
        { label: 'Số điện thoại', key: 'phoneNumber' },
        { label: 'Gói dịch vụ', key: 'packageName' },
        { label: 'Mã gói', key: 'packageCode' },
        // { label: 'Partner', key: 'customerPartnerName' },
        { label: 'Danh xưng', key: 'title', required: true },
        { label: 'Tạo nhóm Zalo', key: 'useZaloGroup' },
      ],
      titleOpts: [
        { text: 'Cô', value: '0' },
        { text: 'Chú', value: '1' },
        { text: 'Anh', value: '2' },
        { text: 'Chị', value: '3' },
        { text: 'Em', value: '4' },
      ],
      useZaloGroupOpts: [
        { text: 'Có', value: 'auto' },
        { text: 'Nhóm chung', value: 'shared' },
        { text: 'Không', value: 'none' },
      ],
      zaloGroups: [],
      loadingGroups: false,
      sharedGroupId: null,
      data: [],
    };
  },
  methods: {
    // Nap 1 lan, cung logic phan trang voi ImportModal.vue (GetValidGroupOA gioi han 50/lan)
    async loadZaloGroups() {
      if (this.zaloGroups.length || this.loadingGroups) return;
      try {
        this.loadingGroups = true;
        let offset = 0;
        let total = null;
        let groups = [];
        for (let page = 0; page < ZALO_GROUP_MAX_PAGE; page++) {
          const res = await this.$api.get('/ZaloZnsLog/GetValidGroupOA', {
            params: { offset, count: ZALO_GROUP_PAGE_SIZE },
          });
          const batch = res?.data?.groups || [];
          if (total === null) total = parseInt(res?.data?.total ?? 0, 10) || 0;
          groups = groups.concat(batch);
          offset += ZALO_GROUP_PAGE_SIZE;
          if (!batch.length || groups.length >= total) break;
        }
        this.zaloGroups = groups;
      } catch (error) {
        this.zaloGroups = [];
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message || 'Không tải được danh sách nhóm Zalo.',
        });
      } finally {
        this.loadingGroups = false;
      }
    },
    getCustomerPartnerName(id) {
      const partner = this.partners?.find((item) => item.id == id);
      if (!partner || !partner.value) {
        return 'N/A';
      }

      // Lấy phần trước dấu phẩy đầu tiên
      return partner.value.split(',')[0].trim();
    },

    // async getCustomerPartnerName(id) {
    //   try {
    //     const { data } = await this.$api.get(`CustomerPartner/${id}`);
    //     return data.name;
    //   } catch (error) {
    //     this.$toastr.e({
    //       title: 'Lỗi',
    //       msg: error.message || 'Không thể lấy thông tin đối tác',
    //     });
    //     return 'N/A';
    //   }
    // },
    resetModal() {
      this.form = {};
      this.data = [];
      this.isChange = false;
      this.submitted = false;
    },
    async handleConfirm() {
      return await this.$swal({
        title: 'Xác nhận?',
        text: `Dữ liệu thay đổi chưa được lưu, xác nhận thoát?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });
    },
    async handleSubmit() {
      this.submitted = true;

      if (!this.form.title) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng chọn danh xưng',
        });
        return;
      }

      if (this.isSharedMode && !this.sharedGroupId) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng chọn nhóm chung',
        });
        return;
      }

      this.loading = true;

      try {
        // Khong dung nhom Zalo khi chon "Khong"; ca "tu dong" lan "nhom chung" van tinh la co dung
        const useZaloGroup = this.form.useZaloGroup?.value !== 'none';

        // Update title first
        const updatePayload = {
          id: this.form.id,
          name: this.form.name,
          title: this.form.title?.value ? Number(this.form.title.value) : null,
          phoneNumber: this.form.phoneNumber,
          gender: this.form.gender,
          birthYear: this.form.birthYear,
          yearOfIllness: this.form.yearOfIllness,
          purchaseDate: this.form.purchaseDate,
          coachId: this.form.coachId,
          reasonout: this.form.reasonout,
          diseaseType: this.form.diseaseType,
          courseId: this.form.courseId,
          contactSource: this.form.contactSource,
          packageId: this.form.packageId,
          customerPartnerId: this.form.customerPartnerId,
          status: this.form.status,
          onboardGroup: this.form.onboardGroup,
          useZaloGroup,
          // Gan san nhom chung duoc chon - HandleCustomerAcceptAsync se doc thang tu
          // entity (khong tao nhom moi, khong tru quota), giong het luong man duyet import.
          zaloGroupId: this.isSharedMode ? this.sharedGroupId : null,
          zaloGroup: this.isSharedMode
            ? this.sharedGroup?.group_link ?? null
            : null,
        };
        await this.$api.put(
          `/CustomerReceives/update/${this.form.id}`,
          updatePayload,
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 60000,
          },
        );

        // Then accept
        const payload = {
          id: this.form.id,
          phoneNumber: this.form.phoneNumber,
          courseId: this.form.courseId,
          packageId: this.form.packageId,
          coachId: this.form.coachId,
          customerPartnerId: this.form.customerPartnerId,
          gender: this.form.gender,
          useZaloGroup,
          // Gửi thẳng nhóm đã chọn để BE gán luôn, không phụ thuộc bước update phía trên
          zaloGroupId: this.isSharedMode ? this.sharedGroupId : null,
          zaloGroup: this.isSharedMode
            ? this.sharedGroup?.group_link ?? null
            : null,
          // Sinh mật khẩu mới và ghi thẳng xuống tài khoản, rồi gửi qua ZNS
          resetPassword: this.form.resetPassword === true,
        };
        const acceptRes = await this.$api.put(
          `/CustomerReceives/accept/${this.form.id}`,
          payload,
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 60000,
          },
        );

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Cập nhật thành công',
        });

        if (acceptRes?.data?.quotaPurchased) {
          this.$toastr.i({
            title: 'Thông báo',
            msg: 'Hệ thống đã tự động mua thêm quota nhóm Zalo để tạo nhóm mới cho khách hàng này.',
          });
        }

        // Chỉ load lại/chuyển tab/đóng modal khi accept THẬT SỰ thành công — trước
        // đây 3 dòng này nằm trong finally nên chạy cả khi lỗi, khiến modal tự
        // đóng và tự nhảy sang "Danh sách tham gia" dù khách chưa được accept,
        // nhìn như tab kia "chưa kịp cập nhật" trong khi thực ra chưa hề cập nhật.
        this.$emit('load-data');
        this.$emit('switch-tab', 'CustomerInProcess');
        this.$bvModal.hide('accept-modal');
      } catch (error) {
        if (await handleZaloOutOfMoney(this, error)) return;
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Đã đạt hạn mức tạo nhóm hoặc đã có lỗi xảy ra.',
        });
      } finally {
        this.loading = false;
      }
    },
    async handleCancel() {
      if (this.isChange) {
        const confirm = await this.handleConfirm();
        if (confirm) {
          this.$bvModal.hide('accept-modal');
        }
      } else {
        this.$bvModal.hide('accept-modal');
      }
    },
  },
  computed: {
    ...mapState(['courses', 'partners']),
    isSharedMode() {
      return this.form.useZaloGroup?.value === 'shared';
    },
    sharedGroup() {
      return this.zaloGroups.find((g) => g.group_id === this.sharedGroupId);
    },
  },
  watch: {
    isSharedMode(val) {
      if (val) this.loadZaloGroups();
    },
    targetItem: {
      deep: true,
      handler(val) {
        this.submitted = false;
        const customerPartnerName = this.getCustomerPartnerName(
          val.customerPartnerId,
        );
        const titleValue = val.title !== null && val.title !== undefined ? String(val.title) : null;
        const titleObj = titleValue ? this.titleOpts.find((t) => t.value === titleValue) || null : null;
        this.form = {
          id: val.id,
          phoneNumber: val.phoneNumber,
          name: val.name,
          packageName: val.packageName,
          packageCode: val.packageCode,
          courseId: val.courseId,
          packageId: val.packageId,
          coachId: val.coachId,
          customerPartnerId: val.customerPartnerId,
          customerPartnerName,
          gender: val.gender,
          title: titleObj,
          birthYear: val.birthYear,
          yearOfIllness: val.yearOfIllness,
          purchaseDate: val.purchaseDate,
          reasonout: val.reasonout,
          diseaseType: val.diseaseType,
          contactSource: val.contactSource,
          status: val.status,
          onboardGroup: val.onboardGroup,
          // Mac dinh KHONG tao nhom o buoc accept - tranh ton quota GMF-10 ngoai y muon,
          // admin phai chu dong chon "Co (tu dong)"/"Nhom chung" moi lan accept neu can.
          useZaloGroup: { text: 'Không', value: 'none' },
        };
        this.sharedGroupId = null;
        this.data = [
          {
            ...val,
            customerPartnerName,
          },
        ];
      },
    },
  },
};
</script>

<style lang="scss" scoped>

.shared-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
}

.bulk-select {
  width: auto;
  min-width: 260px;
}

.badge-login-type {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 3px;
  vertical-align: middle;
  white-space: nowrap;
}

// Dung dung mau/kieu cua nut dang nhap that tung ben, khong phai mau tuy chon:
//  - Zalo: nen xanh duong thuong hieu #0068FF, chu trang - dung nhu nut cua ho.
//  - Google: nen trang, vien xam, kem icon G 4 mau that - dung nhu nut "Sign in with Google".
.badge-zalo {
  background: #0068ff;
  color: #fff;
  letter-spacing: 0.02em;
}

.badge-google {
  background: #fff;
  color: #3c4043;
  border: 1px solid #dadce0;
  font-weight: 600;

  &__icon {
    width: 11px;
    height: 11px;
    margin-right: 4px;
  }
}

// .checkbox-inline (theme) chỉ canh giữa các phần tử .checkbox đã style riêng, không áp
// dụng cho <input type="checkbox"> thô nên bị lệch dòng với chữ - canh lại thủ công ở đây.
.reset-password-check {
  align-items: center;

  input[type='checkbox'] {
    margin-right: 0.5rem;
  }
}

.title-cell {
  min-width: 140px;
  vertical-align: middle;
}

.zalo-cell {
  min-width: 120px;
  vertical-align: middle;
}

::v-deep .title-select {
  margin-bottom: 0;

  .form-group {
    margin-bottom: 0;
  }

  .multiselect {
    min-height: 38px;
  }

  .multiselect__tags {
    min-height: 38px;
    padding: 6px 40px 0 8px;
    border-radius: 4px;
  }

  .multiselect__single {
    margin-bottom: 0;
    padding: 0;
  }

  .multiselect__placeholder {
    margin-bottom: 0;
    padding: 0;
  }

  &.is-invalid .multiselect__tags {
    border-color: #dc3545 !important;
  }
}

::v-deep .zalo-select {
  margin-bottom: 0;

  .form-group {
    margin-bottom: 0;
  }

  .multiselect {
    min-height: 38px;
  }

  .multiselect__tags {
    min-height: 38px;
    padding: 6px 40px 0 8px;
    border-radius: 4px;
  }

  .multiselect__single {
    margin-bottom: 0;
    padding: 0;
  }

  .multiselect__placeholder {
    margin-bottom: 0;
    padding: 0;
  }
}
</style>

<style lang="scss">
#accept-modal {
  .modal-body {
    overflow: visible !important;
  }

  .b-overlay-wrap {
    overflow: visible !important;
  }

  .table-responsive {
    overflow: visible !important;
  }

  table {
    overflow: visible !important;
  }

  .multiselect__content-wrapper {
    position: absolute !important;
    z-index: 9999 !important;
    max-height: 200px !important;
  }
}
</style>
